class PromoCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.#update();
    this.#timer = window.setInterval(() => this.#update(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #update() {
    const target = new Date(this.getAttribute('end-date') || '');
    const remaining = target.getTime() - Date.now();

    if (Number.isNaN(target.getTime())) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    const seconds = Math.max(0, Math.floor(remaining / 1000));
    const values = {
      days: Math.floor(seconds / 86400),
      hours: Math.floor((seconds % 86400) / 3600),
      minutes: Math.floor((seconds % 3600) / 60),
      seconds: seconds % 60,
    };

    for (const [unit, value] of Object.entries(values)) {
      const element = this.querySelector(`[data-countdown-value="${unit}"]`);
      if (element) element.textContent = String(value).padStart(2, '0');
    }
  }
}

if (!customElements.get('promo-countdown')) {
  customElements.define('promo-countdown', PromoCountdown);
}
